import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { pairwise } from 'rxjs/operators';
import { CustomProductsService } from '../custom-products.service';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { NgIf, NgFor } from '@angular/common';
import { CustomProductCardComponent } from '../custom-product-card/custom-product-card.component';
import { ListCardComponent } from '../list-card/list-card.component';
import { I18nModule } from '@spartacus/core';

@Component({
    selector: 'app-custom-products-browse-all-content',
    templateUrl: './custom-products-browse-all-content.component.html',
    styleUrls: ['./custom-products-browse-all-content.component.scss'],
    imports: [InfiniteScrollDirective, NgIf, NgFor, CustomProductCardComponent, ListCardComponent, I18nModule]
})
export class CustomProductsBrowseAllContentComponent implements OnInit {
  browseType = 'browseAll';
  portsList: any;
  @Input() grid: any;
  @Input() list: any;
  @Input() sortData: any;
  showNotAvailableMsg = false;
  enableLoader = false;
  loaderShow = false;
  noOfItemsToShow = 8;
  productListCopy: any;
  reachedToEnd = false;
  page = 0;
  currentPage = 0;
  pageSize = 2;
  notScrolly = true;
  nextProducts: any;
  filterUrl = null;

productList = [];
  constructor(private customProductService: CustomProductsService, private cd: ChangeDetectorRef ) {


  }

  ngOnInit(): void {
    this.products(this.currentPage, this.pageSize);
    this.customProductService.refreshCompProduct$.subscribe(result => {
      if (result != null) {
        this.enableLoader = true;
        this.products(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue);
      }
    });
    this.customProductService.languageChange$.subscribe(data => {
      if (data != null) {
        this.enableLoader = true;
        this.products(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue);
      }
    });

    this.customProductService.sortChange$.pipe(pairwise()).subscribe(([previous, current]) => {
      if (previous !== current) {
        this.page = 0;
        this.reachedToEnd = false;
        this.currentPage = 0;

        this.products(this.currentPage, this.pageSize, current,  this.customProductService.filterValue);
      }
    });

    this.customProductService.searchInput$.pipe(pairwise()).subscribe(([previous, current]) => {
      if (previous !== current) {
      this.reachedToEnd = false;
      this.currentPage = 0;
      this.pageSize = 2;
      this.cd.detectChanges();
      this.filterUrl = current;
      this.products(0 , this.pageSize , this.sortData , current);
      }
    });

    this.customProductService.filterInput$.pipe(pairwise()).subscribe(([previous, current]) => {
      if (previous !== current) {
      this.cd.detectChanges();
      this.reachedToEnd = false;
      this.currentPage = 0;
      this.pageSize = 2;
      this.filterUrl = current;
      this.customProductService.filterValue = this.filterUrl;
      if (this.filterUrl != null){
        this.products(0 , 2, this.sortData , current);
      }else{
        this.products(0, 2, this.sortData);
      }
    }
    });
  }

  onScroll(): any{
    if (!this.reachedToEnd){
    this.loaderShow = true;
    setTimeout(() => {
      if (!this.reachedToEnd){
        this.loadNextDataProducts();
      }
      }, 1000);
    }
    // }
  }

  loadNextDataProducts(): any {
    this.currentPage += 1;
    if (!this.reachedToEnd){
    this.customProductService.getAllProducts(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue)
    .subscribe(data => {
      this.loaderShow = false;
      this.nextProducts = data;

      if (data.pagination.totalResults === 0) {
        this.reachedToEnd = true;
        this.loaderShow = false;
      }

      if (data.products !== undefined && data.products.length > 0){
        const productsFilterData = this.sortDataWithPort(data);
        this.productList = this.productList.concat(productsFilterData);
      }
    });
  }else{
    this.loaderShow = false;
  }

  }
  products(currentPage?, pageSize?, sort? , searchInput?): any {
    this.customProductService.getAllProducts(currentPage, pageSize, sort , searchInput).subscribe(data => {
     // this.productList=this.shuffle(productDataFilter);
     this.showNotAvailableMsg = false;
    // this.productList = data.products;
       this.productList = this.sortDataWithPort(data);
      // this.productData = this.sampleData;
     if (this.productList.length === 0) {
        this.enableLoader = false;
        this.showNotAvailableMsg = true;
      }

      // this.productListCopy = this.productList;


    }, err => {
    //  this.toastService.show('Browse by Product - Something went wrong. Please try again later');
      this.enableLoader = false;
    });
  }
   shuffle(array): any {
    // tslint:disable-next-line:one-variable-per-declaration
    let currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  sortDataWithPort(data): any{
    const productDataFilter = [];
    let productListArray = [];
    // this.productList =[...data.products];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0 ; i < data.products.length; i++){
       if (data.products[i].ports.length > 0){
        productListArray.push(data.products[i]);
       }
    }
    // productListArray = Array.from(data.products);
    this.enableLoader = false;
    // tslint:disable-next-line:prefer-for-of
    // for (let i = 0; i < productListArray.length; i++){
    //       // tslint:disable-next-line:prefer-for-of
    //       for (let j = 0; j < productListArray[i].ports.length; j++){
    //         //  let productst=this.productList[i];
    //           const productst = Object.assign({}, productListArray[i]);
    //           productst.portList = productListArray[i].ports[j];
    //           productDataFilter.push(productst);
    //       }
    // }
    return productListArray;
  }
}
